import React, { useEffect, useState } from "react";
import { CgPlayListRemove } from "react-icons/cg";
import { AiOutlineCheck } from "react-icons/ai";
import { Spinner } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const DetalhamentoTipoDivergencia = ({ data }) => {
  const { request, data: requestData, isLoading } = useApiClient();
  const [criticas, setCriticas] = useState([]);

  useEffect(() => {
    const params = data.sqTipoAutomacao;
    request(apiRoutes.fiscalizacao.parametrizacao.consultaCriticasTipoDivergencia, { SqTipoAutomacao: params });
  }, [request, data.sqTipoAutomacao]);

  useEffect(() => {
    if (requestData) {
      setCriticas(requestData.result);
    }
  }, [requestData]);

  return isLoading ? (
    <span>
      <Spinner animation="border" role="status" />
      Carregando críticas...
    </span>
  ) : (
    <div>
      {criticas.length > 0 ? (
        <div className="text-left m-4">
          <h5>Críticas associadas:</h5>
          <ul className="list-group">
            {criticas.map((item) => (
              <li className="list-group-item py-4" key={item.codObrigacao}>
                <AiOutlineCheck className="text-success" /> <strong>{item.codObrigacao}</strong> - {item.nomObrigacao}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="text-center m-4">
          {" "}
          <CgPlayListRemove className="text-danger" /> <span className="text-muted">Sem críticas associadas</span>
        </div>
      )}
    </div>
  );
};

export default DetalhamentoTipoDivergencia;
